<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header">
                <h3>{{ $t("headers.nfcTags") }}</h3>
            </div>
            <div class="card-body">
                <table class="table table-striped table-hover table-responsive-md text-center">
                    <thead>
                        <tr>
                            <th>{{ $t("nfcTag.patrolRoute") }}</th>
                            <th>{{ $t("nfcTag.name") }}</th>
                            <th>{{ $t("nfcTag.id") }}</th>
                            <th>{{ $t("nfcTag.order") }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody v-if="nfctags.length">
                        <tr
                            v-for="nfc in nfctags"
                            :key="nfc.id"
                            class="align-middle"
                        >
                            <td>{{ nfc.patrol_route_name }}</td>
                            <td>{{ nfc.name }}</td>
                            <td>{{ nfc.uid }}</td>
                            <td>{{ nfc.order }}</td>
                            <td>
                                <button
                                    class="btn btn-primary btn-sm me-2"
                                    @click="goTo(nfc.id)"
                                >
                                    <icon icon="Search"></icon>
                                </button>
                                <button
                                    class="btn btn-secondary btn-sm me-2"
                                    @click="editNfc(nfc.id)"
                                >
                                    <icon icon="EditPen"></icon>
                                </button>
                                <button
                                    class="btn btn-danger btn-sm"
                                    @click="deleteNfc(nfc)"
                                >
                                    <icon icon="Trash"></icon>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="5" class="text-center text-muted py-3">
                                {{ $t("nfcTag.notFound") }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import { goToDetail, goToEdit, deleteItem } from '@/utils/actions';

export default {
    components: {
        Icon,
    },
    data() {
        return {
            nfctags: []
        }
    },
    created() {
        this.getNfcTags();
    },
    methods: {
        getNfcTags() {
            this.$store.getters.api.get(`/dashboard/${this.$route.params.slug}/nfc`)
            .then(response => {
                this.nfctags = response.data;
            })
            .catch(error => {
                console.error("Error loading nfc tags.",error);
            });
        },
        goTo(nfcId) {
            goToDetail({
                router: this.$router,
                routeName: "NfcTagDetailView",
                slug: this.$route.params.slug,
                id: nfcId,
            })
        },
        editNfc(nfcId) {
            goToEdit({
                router: this.$router,
                routeName: "NfcTagEditView",
                slug: this.$route.params.slug,
                id: nfcId
            })
        },
        deleteNfc(nfc) {
            deleteItem({
                api: this.$store.getters.api,
                slug: this.$route.params.slug,
                model: "nfc",
                id: nfc.id,
                confirmMessage: this.$t("utils.deleteConfirm", { name: nfc.name}),
                successCallback: this.getNfcTags,
            });
        },
    }
}
</script>